import { render, staticRenderFns } from "./ListGenerators.vue?vue&type=template&id=b982bdc2&"
import script from "./ListGenerators.vue?vue&type=script&lang=js&"
export * from "./ListGenerators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports